import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithReauth from '@/pages/shared/base-query-auth';
import { runMutationOnce, runQueryOnce, runTableQuery } from '@/pages/shared/rtk-query-helpers';

export const numberTypeFieldApi = createApi({
    reducerPath: 'numberTypeFieldApi',
    baseQuery: baseQueryWithReauth,
    endpoints: (builder) => ({
        getTableData: builder.mutation({
            query: (filter) => ({
                url: '/api/utilities/numberTypeFields/list',
                method: 'POST',
                body: filter,
            }),
        }),
        removeNumberTypeField: builder.mutation({
            query: (id) => ({
                url: `/api/utilities/numberTypeFields/delete/${id}`,
                method: 'DELETE',
            }),
        }),
        updateField: builder.mutation({
            query: (model) => ({
                url: '/api/utilities/numberTypeFields/update',
                method: 'POST',
                body: model,
            }),
        }),
        createField: builder.mutation({
            query: (model) => ({
                url: '/api/utilities/numberTypeFields/create',
                method: 'POST',
                body: model,
            }),
        }),
        updateFieldValue: builder.mutation({
            query: (model) => ({
                url: '/api/utilities/numberTypeFieldValues/update',
                method: 'POST',
                body: model,
            }),
        }),
        createFieldValue: builder.mutation({
            query: (model) => ({
                url: '/api/utilities/numberTypeFieldValues/create',
                method: 'POST',
                body: model,
            }),
        }),
        deleteFieldValue: builder.mutation({
            query: (id) => ({
                url: `/api/utilities/numberTypeFieldValues/delete/${id}`,
                method: 'DELETE',
            }),
        }),
        exportField: builder.mutation({
            query: (numberTypeFieldId) => ({
                url: '/api/utilities/exportNumberFieldValues',
                method: 'GET',
                params: { numberTypeFieldId },
                responseHandler: (response) => (response.ok ? response.blob() : response.text()),
            }),
        }),
        getSitesField: builder.query({
            query: () => ({ url: '/api/utilities/numberTypeFields/sites' }),
            keepUnusedDataFor: 0,
        }),
        uploadCSV: builder.mutation({
            query: ({ formData, siteId }) => ({
                url: `/api/utilities/importNumberFieldValues/${siteId}`,
                method: 'POST',
                body: formData,
            }),
        }),
    }),
});

export const runNumberTypeFieldQuery = (dispatch, endpointName, arg) =>
    runQueryOnce(dispatch, numberTypeFieldApi.endpoints[endpointName], arg);

export const runNumberTypeFieldMutation = (dispatch, endpointName, arg) =>
    runMutationOnce(dispatch, numberTypeFieldApi.endpoints[endpointName], arg);

export const runNumberTypeFieldTableQuery = (dispatch, requestData) =>
    runTableQuery(dispatch, numberTypeFieldApi.endpoints.getTableData, requestData);

export default numberTypeFieldApi;
